import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FileModal from './FileModal';
import { getTimeDifference } from './../../utils/utils';
import styles from './VideoCard.module.css';
import UserImageIcon from './../general-components/UserImageIcon';
import { faFilm, faVideo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const VideoCard: React.FC<{
    video: any;
}> = ({ video }) => {
    const { t } = useTranslation();
    const [showVideo, setShowVideo] = useState(false);

    return (
        <>
            <div className={styles.videocard}>
                <div
                    className={styles.videoHeader}
                    style={{
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'center',
                    }}
                >
                    <div className={styles.authorIcon}>
                        <UserImageIcon />
                    </div>
                    <span className={styles.author}>{video.author}</span>
                </div>
                <div
                    className={styles.videoImage}
                    onClick={() => setShowVideo(true)}
                >
                    {video.thumbnail !== null && (
                        <img src={video.thumbnail} alt="" />
                    )}
                    {video.thumbnail === null && (
                        <div
                            className={styles.videoImagePlaceholder}
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '100%',
                            }}
                        >
                            <FontAwesomeIcon icon={faFilm} size="4x" />
                        </div>
                    )}
                </div>
                <div className={styles.videoBody}>
                    <p className={styles.postTime}>
                        {getTimeDifference(
                            new Date(video.createdAt).getTime()
                        ) +
                            ' ' +
                            t('videoOverview.videoCard.timeAgo')}
                    </p>
                    <p
                        className={styles.videoTitle}
                        onClick={() => setShowVideo(true)}
                    >
                        {video.title}
                    </p>
                    {video.tags.length !== 0 && (
                        <div className={styles.tagsWrapper}>
                            {video.tags?.map((tag: string) => (
                                <span key={video._id + tag}>
                                    {t('videoOverview.videoCard.tags.prefix')}
                                    {tag}
                                </span>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            {showVideo && (
                <FileModal
                    file={{
                        url: video.video_file,
                        title: video.title,
                        documentType: 'video',
                    }}
                    close={() => setShowVideo(false)}
                />
            )}
        </>
    );
};
export default VideoCard;
